// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Float from "../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Location$Showside from "./Location.bs.js";
import Throttle from "lodash-es/throttle";
import * as LocationConfig$Showside from "./LocationConfig.bs.js";
import * as PictureInPicture2SessionStorage$Showside from "./PictureInPicture2SessionStorage.bs.js";
var init = {
  mediaId: undefined,
  aspectRatio: undefined,
  backLocation: undefined,
  time: undefined,
  muted: false,
  setMediaId: undefined,
  saveTime: undefined,
  setMuted: undefined
};
var context = React.createContext(init);
var provider = context.Provider;
function PictureInPictureContext$Provider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
    value: value,
    children: children
  });
}
PictureInPictureContext$Provider.displayName = "PictureInPictureContext.Provider";
var Provider = {
  provider: provider,
  make: PictureInPictureContext$Provider
};
function use(param) {
  return React.useContext(context);
}
function PictureInPictureContext(Props) {
  var children = Props.children;
  var match = LocationConfig$Showside.use(undefined);
  var namespace = match.namespace;
  var match$1 = React.useState(function () {
    return PictureInPicture2SessionStorage$Showside.getFromSessionStorage("mediaId");
  });
  var setMediaId = match$1[1];
  var mediaId = match$1[0];
  var match$2 = React.useState(function () {
    return Belt_Option.flatMap(PictureInPicture2SessionStorage$Showside.getFromSessionStorage("aspectRatio"), Belt_Float.fromString);
  });
  var setAspectRatio = match$2[1];
  var aspectRatio = match$2[0];
  var match$3 = React.useState(function () {
    return Belt_Option.isSome(PictureInPicture2SessionStorage$Showside.getFromSessionStorage("mediaId"));
  });
  var setMuted = match$3[1];
  var muted = match$3[0];
  var match$4 = React.useState(function () {
    return Belt_Option.flatMap(PictureInPicture2SessionStorage$Showside.getFromSessionStorage("time"), Belt_Float.fromString);
  });
  var setTime = match$4[1];
  var time = match$4[0];
  var match$5 = React.useState(function () {
    return Belt_Option.map(PictureInPicture2SessionStorage$Showside.getFromSessionStorage("backLocation"), function (param) {
      return Location$Showside.fromUrl(namespace, param);
    });
  });
  var setBackLocation = match$5[1];
  var backLocation = match$5[0];
  React.useEffect(function () {
    PictureInPicture2SessionStorage$Showside.setToSessionStorage("mediaId", Belt_Option.getWithDefault(mediaId, ""));
  }, [mediaId]);
  React.useEffect(function () {
    PictureInPicture2SessionStorage$Showside.setToSessionStorage("aspectRatio", Belt_Option.mapWithDefault(aspectRatio, "", function (prim) {
      return String(prim);
    }));
  }, [aspectRatio]);
  React.useEffect(function () {
    PictureInPicture2SessionStorage$Showside.setToSessionStorage("time", Belt_Option.mapWithDefault(time, "", function (prim) {
      return String(prim);
    }));
  }, [time]);
  React.useEffect(function () {
    PictureInPicture2SessionStorage$Showside.setToSessionStorage("backLocation", Belt_Option.mapWithDefault(backLocation, "", function (loc) {
      return window.location.origin + "?" + Location$Showside.toQueryString(namespace, loc);
    }));
  }, [backLocation]);
  var saveTime = Throttle(function (time) {
    PictureInPicture2SessionStorage$Showside.setToSessionStorage("time", String(time));
  }, 3000);
  var value = React.useMemo(function () {
    return {
      mediaId: mediaId,
      aspectRatio: aspectRatio,
      backLocation: backLocation,
      time: time,
      muted: muted,
      setMediaId: function (backLocation, time, aspectRatio, mutedOpt, mediaId) {
        var muted = mutedOpt !== undefined ? mutedOpt : false;
        if (mediaId !== undefined) {
          if (backLocation !== undefined) {
            var location_quickView = {
              mediaId: mediaId,
              mediaParentId: backLocation.quickView.mediaParentId,
              albumId: undefined,
              panelClosed: undefined,
              whichList: undefined,
              productId: undefined,
              relatedMediaProductIds: backLocation.quickView.relatedMediaProductIds,
              relatedMediaCategoryId: backLocation.quickView.relatedMediaCategoryId,
              variantId: undefined,
              photoZoom: undefined,
              time: undefined
            };
            var location_quickNav = backLocation.quickNav;
            var $$location = {
              quickView: location_quickView,
              quickNav: location_quickNav
            };
            Curry._1(setBackLocation, function (param) {
              return $$location;
            });
          } else {
            var $$location$1 = Location$Showside.fromUrl(namespace, window.location.href);
            Location$Showside.goTo(namespace, undefined, undefined, $$location$1.quickNav, undefined, undefined, undefined);
            Curry._1(setBackLocation, function (param) {
              return $$location$1;
            });
          }
        } else if (backLocation !== undefined) {
          var quickView = backLocation.quickView;
          var quickView_mediaId = quickView.mediaId;
          var quickView_mediaParentId = quickView.mediaParentId;
          var quickView_albumId = quickView.albumId;
          var quickView_panelClosed = quickView.panelClosed;
          var quickView_whichList = quickView.whichList;
          var quickView_productId = quickView.productId;
          var quickView_relatedMediaProductIds = quickView.relatedMediaProductIds;
          var quickView_relatedMediaCategoryId = quickView.relatedMediaCategoryId;
          var quickView_variantId = quickView.variantId;
          var quickView_photoZoom = quickView.photoZoom;
          var quickView$1 = {
            mediaId: quickView_mediaId,
            mediaParentId: quickView_mediaParentId,
            albumId: quickView_albumId,
            panelClosed: quickView_panelClosed,
            whichList: quickView_whichList,
            productId: quickView_productId,
            relatedMediaProductIds: quickView_relatedMediaProductIds,
            relatedMediaCategoryId: quickView_relatedMediaCategoryId,
            variantId: quickView_variantId,
            photoZoom: quickView_photoZoom,
            time: time
          };
          Location$Showside.goTo(namespace, undefined, quickView$1, backLocation.quickNav, undefined, undefined, undefined);
          Curry._1(setBackLocation, function (param) {});
        } else {
          Curry._1(setBackLocation, function (param) {});
        }
        Curry._1(setMediaId, function (param) {
          return mediaId;
        });
        Curry._1(setTime, function (param) {
          return time;
        });
        Curry._1(setMuted, function (param) {
          return muted;
        });
        if (aspectRatio !== undefined) {
          return Curry._1(setAspectRatio, function (param) {
            return aspectRatio;
          });
        }
      },
      saveTime: saveTime,
      setMuted: function (value) {
        Curry._1(setMuted, function (param) {
          return value;
        });
      }
    };
  }, [mediaId, aspectRatio, Belt_Option.map(backLocation, function (param) {
    return Location$Showside.toQueryString(namespace, param);
  }), time, muted]);
  return React.createElement(PictureInPictureContext$Provider, {
    value: value,
    children: children
  });
}
PictureInPictureContext.displayName = "PictureInPictureContext";
var make = PictureInPictureContext;
export { init, context, Provider, use, make };
/* context Not a pure module */